// extracted by mini-css-extract-plugin
export var copyIcon = "_ri-2";
export var discountCard = "_ri-0";
export var discountCode = "_ri-3";
export var discountContent = "_ri-1";
export var loadingCard = "_ri-4";